export const STATUSES = ['PAID', 'FORECAST', 'UNPAID', 'SIGNED', 'OVERDUE'];

export const PERFORMANCE_STATE = [
	'WARNING',
	'NEEDS_ATTENTION',
	'NEUTRAL',
	'GOOD',
];
